import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/adobe': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M315.5 64h170.9v384zM196.5 64l-170.9 384v-384h170.9zM256 206.1l107.5 241.9h-73l-30.7-76.8h-78.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/adobe.js
// module id = 697
// module chunks = 0